import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container footer__container">
        <Link to="/privacy-policy">Privacy policy</Link>
        <div className="footer__copyright">&copy; DesignsTattoo {new Date().getFullYear()}</div>
      </div>
    </footer>
  );
};

export default Footer;